"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3300],{

/***/ 3300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./node_modules/exenv/index.js
var exenv = __webpack_require__(58875);
var exenv_default = /*#__PURE__*/__webpack_require__.n(exenv);
// EXTERNAL MODULE: ./app/reducers/ContactJourneyRedux.js
var ContactJourneyRedux = __webpack_require__(81869);
// EXTERNAL MODULE: ./app/reducers/AuthRedux.js
var AuthRedux = __webpack_require__(45228);
// EXTERNAL MODULE: ./app/reducers/AppRedux.js
var AppRedux = __webpack_require__(65518);
// EXTERNAL MODULE: ./app/selectors/index.js
var selectors = __webpack_require__(11256);
// EXTERNAL MODULE: ./app/commonRoutes.json
var commonRoutes = __webpack_require__(20615);
// EXTERNAL MODULE: ./app/config/index.js + 1 modules
var config = __webpack_require__(68080);
// EXTERNAL MODULE: ./components/Header/NavigationBar.js + 2 modules
var NavigationBar = __webpack_require__(38649);
// EXTERNAL MODULE: ./components/Footer/index.js + 8 modules
var Footer = __webpack_require__(47911);
// EXTERNAL MODULE: ./controls/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(88654);
// EXTERNAL MODULE: ./node_modules/react-notification-system/dist/NotificationSystem.js
var NotificationSystem = __webpack_require__(26656);
var NotificationSystem_default = /*#__PURE__*/__webpack_require__.n(NotificationSystem);
// EXTERNAL MODULE: ./app/reducers/AlertRedux.js
var AlertRedux = __webpack_require__(62961);
;// CONCATENATED MODULE: ./components/AlertSystem/index.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var AlertSystem = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(AlertSystem, Component1);
    var _super = _createSuper(AlertSystem);
    function AlertSystem() {
        _classCallCheck(this, AlertSystem);
        return _super.apply(this, arguments);
    }
    _createClass(AlertSystem, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this = this;
                var system = this.ns;
                var alerts = nextProps.alerts;
                var uids = alerts.map(function(n) {
                    return n.uid;
                });
                (system.state.alerts || []).forEach(function(n) {
                    if (uids.indexOf(n.uid) < 0) {
                        system.removeNotification(n.uid);
                    }
                });
                alerts.forEach(function(n) {
                    var _this1 = _this;
                    system.addNotification(_objectSpread({}, n, {
                        onRemove: function() {
                            _this1.props.actions.hide(n.uid);
                            n.onRemove && n.onRemove();
                        }
                    }));
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)((NotificationSystem_default()), {
                    ref: function(el) {
                        return _this.ns = el;
                    }
                }));
            }
        }
    ]);
    return AlertSystem;
}(react.Component);
_defineProperty(AlertSystem, "propTypes", {
    actions: prop_types_default().shape({
        hide: (prop_types_default()).func.isRequired
    }).isRequired,
    alerts: (prop_types_default()).array.isRequired
});
var mapStateToProps = function(state) {
    return {
        alerts: state.alerts
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            hide: AlertRedux/* AlertActionCreators.hide */.$w.hide
        }, dispatch)
    };
};
/* harmony default export */ var components_AlertSystem = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(AlertSystem));

// EXTERNAL MODULE: ./components/FeatureFlag/index.js
var FeatureFlag = __webpack_require__(40839);
;// CONCATENATED MODULE: ./components/Layout/ChatBot.js





var ChatBot = function(param) {
    var isPrivate = param.isPrivate, typeOfLogin = param.typeOfLogin;
    var isAuthenticated = (0,es/* useSelector */.v9)(selectors/* getSessionData */.gP).isAuthenticated;
    return isPrivate && isAuthenticated && typeOfLogin === 'broker' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                children: "\n            window.chatwootSettings = {\n                type: \"standard\",\n                launcherTitle: \"Chatea con nosotros\",\n            };\n            (function (d, t) {\n            var BASE_URL = \"https://app.chatwoot.com\";\n            var g = d.createElement(t),\n                s = d.getElementsByTagName(t)[0];\n            g.src = BASE_URL + \"/packs/js/sdk.js\";\n            g.defer = true;\n            g.async = true;\n            s.parentNode.insertBefore(g, s);\n            g.onload = function () {\n                window.chatwootSDK.run({\n                websiteToken: \"reFQXdBs6kxy7SkS5paJ3VsT\",\n                baseUrl: BASE_URL,\n                });\n            };\n            })(document, \"script\");\n        "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n          @media (max-width: 768px) and (orientation: portrait) {\n            .woot-widget-holder {\n              height: 100svh !important;\n            }\n\n            button.woot-widget-bubble {\n              right: 1% !important;\n              bottom: 30% !important;\n              opacity: 0.7 !important;\n            }\n          }\n        "
            })
        ]
    }) : null;
};
/* harmony default export */ var Layout_ChatBot = (ChatBot);

;// CONCATENATED MODULE: ./components/Layout/UserSessionCheck.js




function UserSessionCheck(param) {
    var isPrivate = param.isPrivate, typeOfLogin = param.typeOfLogin, hideSessionModal = param.hideSessionModal;
    var router = (0,next_router.useRouter)();
    var tokenRefreshed = (0,es/* useSelector */.v9)(selectors/* getSessionData */.gP).tokenRefreshed;
    var shouldBeLogout = (0,es/* useSelector */.v9)(function(state) {
        return state.userSession;
    }).shouldBeLogout;
    (0,react.useEffect)(function() {
        // wait for state reconciliation to complete (i.e.: when the app first loads)
        // Don't logout if user is a contact.
        if (!tokenRefreshed || typeOfLogin === 'contact' || hideSessionModal) {
            return;
        }
        // Same validation as Layout.validatePrivacyRedirection method
        if (isPrivate && shouldBeLogout && tokenRefreshed) {
            window.location.assign('/salir');
        }
    }, [
        tokenRefreshed,
        typeOfLogin,
        isPrivate,
        shouldBeLogout,
        hideSessionModal
    ]);
    return null;
}
/* harmony default export */ var Layout_UserSessionCheck = (UserSessionCheck);

;// CONCATENATED MODULE: ./components/Layout/utils.js
var userRequestLogout = function(currentUserSession, nextUserSession) {
    var isAuthenticated = currentUserSession.isAuthenticated, isUserRequestingLogOut = currentUserSession.isUserRequestingLogOut;
    var n = nextUserSession;
    var userIsNotAuthenticated = isAuthenticated && !n.isAuthenticated;
    var userRequestLogOut = !isUserRequestingLogOut && n.isUserRequestingLogOut;
    return Boolean(userIsNotAuthenticated && userRequestLogOut);
};

// EXTERNAL MODULE: ./components/Layout/styles.js
var styles = __webpack_require__(7632);
;// CONCATENATED MODULE: ./components/Layout/index.js

























function Layout_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Layout_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Layout_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Layout_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Layout_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Layout_defineProperties(Constructor, staticProps);
    return Constructor;
}
function Layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Layout_getPrototypeOf(o) {
    Layout_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Layout_getPrototypeOf(o);
}
function Layout_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Layout_setPrototypeOf(subClass, superClass);
}
function Layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Layout_possibleConstructorReturn(self, call) {
    if (call && (Layout_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Layout_assertThisInitialized(self);
}
function Layout_setPrototypeOf(o, p) {
    Layout_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Layout_setPrototypeOf(o, p);
}
var Layout_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Layout_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Layout_createSuper(Derived) {
    var hasNativeReflectConstruct = Layout_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Layout_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Layout_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Layout_possibleConstructorReturn(this, result);
    };
}
var GOOGLE_MAPS_API_KEY = (0,config["default"])('GOOGLE_MAPS_API_KEY');
next_router["default"].onRouteChangeStart = function(url) {
    nprogress_default().start();
};
next_router["default"].onRouteChangeComplete = function(url) {
    nprogress_default().done();
};
next_router["default"].onRouteChangeError = function() {
    return nprogress_default().done();
};
var Layout = /*#__PURE__*/ function(Component1) {
    "use strict";
    Layout_inherits(Layout, Component1);
    var _super = Layout_createSuper(Layout);
    function Layout(props) {
        Layout_classCallCheck(this, Layout);
        var _this;
        var ref, ref1, ref2;
        _this = _super.call(this, props);
        Layout_defineProperty(Layout_assertThisInitialized(_this), "routeIsLoginPage", function(path) {
            return path && path.replace('/', '').toLowerCase().indexOf('login') === 0;
        });
        _this.state = {
            tokenWasUpdated: false,
            hasError: false
        };
        _this.currentPath = (ref = props.urlData) === null || ref === void 0 ? void 0 : ref.pathname;
        var redirectData = (ref1 = props.urlData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.query) === null || ref2 === void 0 ? void 0 : ref2.redirect;
        if (redirectData) {
            try {
                redirectData = atob(redirectData);
                redirectData = JSON.parse(redirectData);
                _this.redirectData = redirectData;
            } catch (e) {
                _this.redirectData = null;
            }
        }
        var currentPageObject = commonRoutes.find(function(page) {
            return page.page === _this.currentPath.substring(1);
        });
        _this.isPrivate = (currentPageObject === null || currentPageObject === void 0 ? void 0 : currentPageObject.privacy) === 'PRIVATE';
        _this.validatePrivacyRedirection(props);
        return _this;
    }
    Layout_createClass(Layout, [
        {
            // static getDerivedStateFromError(error) {
            //   console.log('getDerivedStateFromError', error)
            //   return { hasError: true }
            // }
            key: "componentDidCatch",
            /*#__PURE__*/ value: function componentDidCatch(error, errorInfo) {
                console.error('componentDidCatch', error, errorInfo);
                this.setState({
                    hasError: true
                });
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                this.validatePrivacyRedirection(nextProps);
                if (!nextProps.hasAppConfig && !nextProps.configLoading) {
                    this.props.actions.getConfigRequest();
                }
            }
        },
        {
            key: "validatePrivacyRedirection",
            value: function validatePrivacyRedirection(nextProps) {
                var sessionData = nextProps.sessionData, typeOfLogin = nextProps.typeOfLogin;
                var tokenRefreshed = nextProps.sessionData.tokenRefreshed;
                // wait for state reconciliation to complete (i.e.: when the app first loads)
                if (!tokenRefreshed) {
                    return;
                }
                // page is private and the user is unauthorized
                if (this.isPrivate && !sessionData.isAuthenticated && tokenRefreshed) {
                    var _urlData = this.props.urlData, pathname = _urlData.pathname, query = _urlData.query;
                    var redirectData = {
                        pathname: pathname,
                        query: query,
                        asPath: this.props.router.asPath
                    };
                    if (typeOfLogin === 'contact') {
                        if (!this.state.tokenWasUpdated) {
                            var _this = this;
                            this.setState({
                                tokenWasUpdated: true
                            }, function() {
                                return _this.props.actions.updateOriginalContactToken(query.token);
                            });
                            return;
                        }
                        this.props.actions.sendContactJourneyEvent('contact-journey', 'redirect');
                        window.location.assign("/login-contact?redirect=".concat(btoa(JSON.stringify(redirectData))));
                    } else if (userRequestLogout(this.props.sessionData, nextProps.sessionData)) {
                        window.location.assign('/ingresar');
                    } else {
                        window.location.assign("/ingresar?redirect=".concat(btoa(JSON.stringify(redirectData))));
                    }
                    return;
                }
                // if it's login page, check if the user is logged in for redirection
                if (this.routeIsLoginPage(this.currentPath) || this.routeIsLoginPage(this.props.router.asPath)) {
                    // if the login process has just completed successfully
                    if (sessionData.isAuthenticated) {
                        if (typeOfLogin === 'contact') {
                            if (!Boolean(this.redirectData)) {
                                // ToDo: default route
                                window.location.assign('/');
                                return;
                            }
                            var ref = this, r = ref.redirectData;
                            // We need to push method because this update the path of the current page
                            // and rerunning its getInitialProps.
                            window.location.assign(r.asPath);
                            return;
                        }
                        if (!Boolean(this.redirectData)) {
                            window.location.assign('/dashboard');
                            return;
                        }
                        var ref3 = this, r1 = ref3.redirectData;
                        window.location.assign(r1.asPath);
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, sessionData = _props.sessionData, hideSessionModal = _props.hideSessionModal, className = _props.className, typeOfLogin = _props.typeOfLogin;
                if (this.state.hasError) {
                    throw new Error('_app');
                }
                var stateIsReconciling = this.isPrivate && (!sessionData.rehydrated || !sessionData.isAuthenticated);
                var children = stateIsReconciling ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* FullPageSpinner */.A, {
                    isOpen: true
                }) : this.props.children;
                var canUseDOM = (exenv_default()).canUseDOM;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: '100%'
                    },
                    className: "jsx-".concat(styles/* layout.__hash */.bK.__hash) + " " + (className || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AlertSystem, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "viewport",
                                    content: "width=device-width, initial-scale=1.0",
                                    className: "jsx-".concat(styles/* layout.__hash */.bK.__hash)
                                }),
                                (!canUseDOM || canUseDOM && !window.google) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                    "cookie-consent": "targeting",
                                    type: "text/javascript",
                                    src: "https://maps.googleapis.com/maps/api/js?key=".concat(GOOGLE_MAPS_API_KEY, "&libraries=places"),
                                    async: true,
                                    defer: true,
                                    className: "jsx-".concat(styles/* layout.__hash */.bK.__hash)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlag/* default */.Z, {
                            name: "layout-head-menu",
                            defaultChildren: this.props.showNavBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* default */.Z, Layout_objectSpread({}, this.props.navBarProps))
                        }),
                        children,
                        this.props.showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_ChatBot, {
                            isPrivate: this.isPrivate,
                            typeOfLogin: typeOfLogin
                        }),
                        !stateIsReconciling && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_UserSessionCheck, {
                            isPrivate: this.isPrivate,
                            typeOfLogin: typeOfLogin,
                            hideSessionModal: hideSessionModal
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* globalStyle.__hash */.KP.__hash,
                            children: styles/* globalStyle */.KP
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* forms.__hash */.cY.__hash,
                            children: styles/* forms */.cY
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* text.__hash */.fL.__hash,
                            children: styles/* text */.fL
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* nProgressStyle.__hash */.$A.__hash,
                            children: styles/* nProgressStyle */.$A
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* layout.__hash */.bK.__hash,
                            children: styles/* layout */.bK
                        })
                    ]
                }));
            }
        }
    ]);
    return Layout;
}(react.Component);
Layout_defineProperty(Layout, "propTypes", {
    // from state
    sessionData: (prop_types_default()).object.isRequired,
    decodedToken: (prop_types_default()).object,
    // from props
    urlData: (prop_types_default()).object.isRequired,
    navBarProps: (prop_types_default()).object,
    typeOfLogin: prop_types_default().oneOf([
        'broker',
        'contact'
    ]),
    //misc
    className: (prop_types_default()).string
});
Layout_defineProperty(Layout, "defaultProps", {
    sessionData: {},
    urlData: {},
    navBarProps: {},
    typeOfLogin: 'broker',
    className: ''
});
var Layout_mapStateToProps = function(state, ownProps) {
    var decodedToken = (0,selectors/* getTokenFields */.Hg)(state);
    var sessionData = (0,selectors/* getSessionData */.gP)(state);
    var hasAppConfig = Object.keys(state.app.config).length > 0;
    var configLoading = state.app.configLoading;
    return Layout_objectSpread({}, ownProps, {
        hasAppConfig: hasAppConfig,
        configLoading: configLoading,
        decodedToken: decodedToken,
        sessionData: sessionData
    });
};
var Layout_mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            updateOriginalContactToken: AuthRedux/* AuthActionCreators.updateOriginalContactToken */.jQ.updateOriginalContactToken,
            sendContactJourneyEvent: ContactJourneyRedux/* ContactJourneyCreators.sendContactJourneyEvent */.hf.sendContactJourneyEvent,
            getConfigRequest: AppRedux/* AppActionCreators.getConfigRequest */.fF.getConfigRequest
        }, dispatch)
    };
};
/* harmony default export */ var components_Layout = ((0,es/* connect */.$j)(Layout_mapStateToProps, Layout_mapDispatchToProps)((0,next_router.withRouter)(Layout)));


/***/ }),

/***/ 20615:
/***/ (function(module) {

module.exports = JSON.parse('[{"pattern":"/","page":"index","privacy":"PUBLIC"},{"pattern":"/login","page":"login","privacy":"PUBLIC"},{"pattern":"/ingresar","page":"login","privacy":"PUBLIC"},{"pattern":"/logout","page":"logout","privacy":"PUBLIC"},{"pattern":"/salir","page":"logout","privacy":"PUBLIC"},{"pattern":"/signup","page":"signup","privacy":"PUBLIC"},{"pattern":"/registrarse","page":"signup","privacy":"PUBLIC"},{"pattern":"/unete","page":"join","privacy":"PUBLIC"},{"pattern":"/reset-password","page":"resetPassword","privacy":"PUBLIC"},{"pattern":"/payment-on-demand/:paymentUUID","page":"payment-on-demand","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/events/:digest/:action","page":"confirm-event","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/better-serve-your-clients","page":"better-serve-your-clients","privacy":"PUBLIC"},{"pattern":"/ayuda-tus-clientes","page":"better-serve-your-clients","privacy":"PUBLIC"},{"pattern":"/acquire-more-properties","page":"acquire-more-properties","privacy":"PUBLIC"},{"pattern":"/capta-propiedades","page":"acquire-more-properties","privacy":"PUBLIC"},{"pattern":"/administrative-support","page":"administrative-support","privacy":"PUBLIC"},{"pattern":"/promote-your-properties","page":"promote-your-properties","privacy":"PUBLIC"},{"pattern":"/promueve-propiedades","page":"promote-your-properties","privacy":"PUBLIC"},{"pattern":"/transaction-management","page":"transaction-management","privacy":"PUBLIC"},{"pattern":"/gestion-transaccion","page":"transaction-management","privacy":"PUBLIC"},{"pattern":"/personal-development","page":"personal-development","privacy":"PUBLIC"},{"pattern":"/desarrollo-personal","page":"personal-development","privacy":"PUBLIC"},{"pattern":"/full-service-only","page":"fullService","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/terms","page":"terms","privacy":"PUBLIC"},{"pattern":"/terminos-condiciones","page":"terms","privacy":"PUBLIC"},{"pattern":"/privacy","page":"privacy","privacy":"PUBLIC"},{"pattern":"/politica-privacidad","page":"privacy","privacy":"PUBLIC"},{"pattern":"/help","page":"help","privacy":"PUBLIC"},{"pattern":"/help/:category","page":"help/categories","privacy":"PUBLIC"},{"pattern":"/help/:category/:id","page":"help/categories","privacy":"PUBLIC"},{"pattern":"/contactanos","page":"contact","privacy":"PUBLIC"},{"pattern":"/contactanos/contact-requested","page":"contact","privacy":"PUBLIC"},{"pattern":"/valuation/new/:section","page":"valuation/new","privacy":"PUBLIC"},{"pattern":"/team","page":"team","privacy":"PUBLIC"},{"pattern":"/equipo","page":"team","privacy":"PUBLIC"},{"pattern":"/equipo/pagina-:page","page":"team","privacy":"PUBLIC"},{"pattern":"/equipo/search/:search","page":"team","privacy":"PUBLIC"},{"pattern":"/equipo/search/:search/pagina-:page","page":"team","privacy":"PUBLIC"},{"pattern":"/equipo/:slug/:id","page":"teamProfile","privacy":"PUBLIC"},{"pattern":"/equipo/:slug/:id/:teamProfileTab/pagina-:page","page":"teamProfile","privacy":"PUBLIC"},{"pattern":"/equipo/:slug/:id/:teamProfileTab","page":"teamProfile","privacy":"PUBLIC"},{"pattern":"/login-contact","page":"contactDashboard/login","privacy":"PUBLIC"},{"pattern":"/bin/:requirement","page":"bin","privacy":"PRIVATE"},{"pattern":"/bin/:requirement/:section","page":"bin","privacy":"PRIVATE"},{"pattern":"/bin/:requirement/property/:property(\\\\d+)","page":"bin/vip","privacy":"PRIVATE"},{"pattern":"/binquality/:requirement/:answer","page":"bin/quality","privacy":"PRIVATE"},{"pattern":"/account/login-contact","page":"contactDashboard/login","privacy":"PRIVATE"},{"pattern":"/account/bin/:requirement","page":"bin","privacy":"PRIVATE"},{"pattern":"/account/bin/:requirement/:section","page":"bin","privacy":"PRIVATE"},{"pattern":"/account/bin/:requirement/property/:property(\\\\d+)","page":"bin/vip","privacy":"PRIVATE"},{"pattern":"/account/binquality/:requirement/:answer","page":"bin/quality","privacy":"PRIVATE"},{"pattern":"/bin/public/:binLeadId/share/:contactShareId","page":"bin/public","privacy":"PUBLIC"},{"pattern":"/bin/public/:binLeadId/share/:contactShareId/:property(\\\\d+)","page":"bin/vipPublic","privacy":"PUBLIC"},{"pattern":"/dashboard/team/network","page":"dashboard/team/network","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/landing-invitation","page":"dashboard/team/landing-invitation","pageName":"LANDING_INVITATION","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/team/tracing","page":"dashboard/team/tracing","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/tracing","page":"dashboard/tracing","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/tracing/:section","page":"dashboard/tracing","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/training-policy","page":"dashboard/training-policy","pageName":"TRAINING_POLICY","privacy":"PRIVATE","skipContractVersionVerification":true},{"pattern":"/dashboard/team/registered-agent/:agentId","page":"dashboard/team/registered-agent","pageName":"BROKER_REGISTRATION","privacy":"PRIVATE"},{"pattern":"/dashboard/team/registerAgent/:section","page":"dashboard/team/registerAgent","pageName":"BROKER_REGISTRATION","privacy":"PRIVATE","ff":[{"name":"hide-classic-broker-registration","value":false}]},{"pattern":"/dashboard/team/commissions/:agentId","page":"dashboard/team/agent-commissions","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/commissions","page":"dashboard/team/commissions","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/tracing-agent/:userId/:agentId","page":"dashboard/team/tracing-agent","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/tracing-agent/:userId/:agentId/:section","page":"dashboard/team/tracing-agent","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/agent/:agentId","page":"dashboard/team/agent-activity","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/billing","page":"dashboard/billing","pageName":"STATEMENT_OF_ACCOUNT","privacy":"PRIVATE"},{"pattern":"/dashboard/transactions/pap","page":"dashboard/transactions/pap","pageName":"MY_COMMISSIONS","privacy":"PRIVATE"},{"pattern":"/dashboard/transactions/commissions","page":"dashboard/transactions/commissions","pageName":"MY_COMMISSIONS","privacy":"PRIVATE"},{"pattern":"/dashboard/contracts","page":"dashboard/contracts","pageName":"CONTRACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/contracts/select-contract","page":"dashboard/contracts/select-contract","pageName":"CONTRACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/contracts/create","page":"dashboard/contracts/contract-detail","pageName":"CONTRACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/contracts/contract-detail","page":"dashboard/contracts/contract-detail","pageName":"CONTRACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/contracts/:contractId","page":"dashboard/contracts/contract-detail","pageName":"CONTRACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/private-property/:propertyId","page":"dashboard/private-vip","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/broker-info","page":"dashboard/broker-info","privacy":"PUBLIC"},{"pattern":"/dashboard/promotions","page":"dashboard/promotions","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/crm/contacts","page":"dashboard/crm/contacts","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/contacts/add","page":"dashboard/crm/addContact","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/contacts/add/:feedback","page":"dashboard/crm/feedback","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/contacts/:idContact/edit","page":"dashboard/crm/addContact","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/contacts/:idContact/reports","page":"dashboard/crm/reports","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/contacts/:idContact","page":"dashboard/crm/contact","pageName":"CONTACTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/crm/close-deal/:id","page":"dashboard/crm/close-deal","pageName":"CONTACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin","page":"dashboard/bin","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/prospections","page":"dashboard/bin/prospections","pageName":"REQUIREMENTS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/bin/prospection/:id","page":"dashboard/bin/prospection","pageName":"REQUIREMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/prospection/:id/accept/","page":"dashboard/bin/acceptRequerimentAccept","pageName":"REQUIREMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/prospection/:id/reject/","page":"dashboard/bin/acceptRequerimentReject","pageName":"REQUIREMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/prospection/:id/:section","page":"dashboard/bin/prospection","pageName":"REQUIREMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/alerts","page":"dashboard/bin/alerts","pageName":"ALERTS","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/recruitment/:recruitmentLeadId/accept","page":"dashboard/recruitment-leads/acceptRequerimentAccept","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/recruitment/:recruitmentLeadId/reject","page":"dashboard/recruitment-leads/acceptRequerimentReject","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/contacto-con-asesor/:recruitmentLeadId/:contacted/","page":"dashboard/recruitment-leads/contactedByBroker","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/profile-card/:userId","page":"bin/profile-card","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/bin/profile-card/:id/pagina-:page","page":"bin/profile-card","pageName":"PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/elearning","page":"dashboard/elearning","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/leads","page":"dashboard/leads","pageName":"PROPERTY_LEADS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/leads/:leadId","page":"dashboard/leads/show","pageName":"PROPERTY_LEADS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/leads/:daLeadAssignationId/accept","page":"dashboard/leads/directAnnonceLeadAccept","pageName":"PROPERTY_LEADS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/leads/:daLeadAssignationId/reject","page":"dashboard/leads/directAnnonceLeadReject","pageName":"PROPERTY_LEADS","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/elearning/:level","page":"dashboard/elearning/level","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/elearning/:level/:lesson","page":"dashboard/elearning/lesson","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/elearning/:level/:lesson/:quiz","page":"dashboard/elearning/quiz","pageName":"COURSES","privacy":"PRIVATE"},{"pattern":"/dashboard/management","page":"dashboard/management","privacy":"PRIVATE"},{"pattern":"/dashboard/profile","page":"dashboard/profile","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/dashboard/payments/checkout/cancel","page":"dashboard/payments/checkout/message","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/payments/checkout/success","page":"dashboard/payments/checkout/message","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/payments","page":"dashboard/payments","pageName":"PAYMENTS_AND_INVOICES","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/payments/:tab","page":"dashboard/payments","pageName":"PAYMENTS_AND_INVOICES","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/team","page":"dashboard/team","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/team/properties","page":"dashboard/team/properties","pageName":"MY_TEAM","privacy":"PRIVATE"},{"pattern":"/dashboard/valuations","page":"dashboard/valuations","pageName":"MY_REPORTS","privacy":"PRIVATE"},{"pattern":"/dashboard/valuations/new","page":"dashboard/valuations/new","pageName":"MY_REPORTS","privacy":"PRIVATE"},{"pattern":"/dashboard/valuations/:propertyId","page":"dashboard/valuations/show","pageName":"MY_REPORTS","privacy":"PRIVATE"},{"pattern":"/dashboard/contacts/calls","page":"dashboard/contacts/calls","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/dashboard/contacts/messages","page":"dashboard/contacts/messages","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/dashboard/contacts/messages/:pageNumber","page":"dashboard/contacts/messages","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/dashboard/property-management","page":"dashboard/property-management","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/calendar","page":"dashboard/calendar","pageName":"CALENDAR","privacy":"PRIVATE","ff":[{"name":"show-on-hl-integration","value":true}]},{"pattern":"/dashboard/properties/create","page":"dashboard/properties/create","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:id/edit","page":"dashboard/properties/edit","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:id/report","page":"dashboard/properties/report","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:id/documents-upload","page":"dashboard/properties/documents-upload","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:id/close","page":"dashboard/properties/close","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:propertyId/virtual-tour","page":"dashboard/properties/virtual-tour","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/:propertyId/virtual-tour-edit","page":"dashboard/properties/virtual-tour-edit","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/highlight-checkout","page":"dashboard/properties/highlight-checkout","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/properties/highlight-order/:highlightOrderId","page":"dashboard/properties/highlight-order","pageName":"MY_PROPERTIES","privacy":"PRIVATE"},{"pattern":"/dashboard/notifications","page":"dashboard/notifications","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/dashboard/portals","page":"dashboard/portals","privacy":"PRIVATE"},{"pattern":"/dashboard/loops","page":"dashboard/loops","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/document-management/:id","page":"dashboard/documentManagement","privacy":"PRIVATE"},{"pattern":"/dashboard/property-document/my-documents","page":"dashboard/myPropertyDocument","pageName":"MY_DOCUMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/property-document/:propertyId","page":"dashboard/property-document","pageName":"MY_DOCUMENTS","privacy":"PRIVATE"},{"pattern":"/dashboard/network","page":"dashboard/network","pageName":"NETWORK","privacy":"PRIVATE"},{"pattern":"/dashboard/network/next-level","page":"dashboard/network/next-level","pageName":"NETWORK","privacy":"PRIVATE"},{"pattern":"/dashboard/network/estimation","page":"dashboard/network/estimation","pageName":"NETWORK","privacy":"PRIVATE"},{"pattern":"/dashboard/network/invitations/:invitationId/:confirmationStatus","page":"dashboard/network/invitations/confirmation","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/network/commissions","page":"dashboard/network/commissions","pageName":"NETWORK_COMMISIONS","privacy":"PRIVATE"},{"pattern":"/dashboard/network-documentation","page":"dashboard/network-documentation","pageName":"DOCUMENTATION","privacy":"PRIVATE"},{"pattern":"/dashboard/network-documentation/:folderId","page":"dashboard/network-documentation/files","pageName":"DOCUMENTATION","privacy":"PRIVATE"},{"pattern":"/dashboard/network/commissions/tree-commissions","page":"dashboard/network/commissions/tree-commissions","pageName":"NETWORK_COMMISIONS","privacy":"PRIVATE"},{"pattern":"/dashboard/network/stats","page":"dashboard/network/stats","pageName":"NETWORK_STATS","privacy":"PRIVATE"},{"pattern":"/dashboard/network/report","page":"dashboard/network/report","pageName":"NETWORK_REPORTS","privacy":"PRIVATE"},{"pattern":"/dashboard/network/report/inventory","page":"dashboard/network/report/inventory","pageName":"NETWORK_REPORTS__INVENTORY","privacy":"PRIVATE"},{"pattern":"/dashboard/network/report/inventory-quality","page":"dashboard/network/report/inventory-quality","pageName":"NETWORK_REPORTS__INVENTORY_QUALITY","privacy":"PRIVATE"},{"pattern":"/dashboard/network/report/contacts","page":"dashboard/network/report/contacts","pageName":"NETWORK_REPORTS__CONTACTS","privacy":"PRIVATE"},{"pattern":"/dashboard/network/report/billing","page":"dashboard/network/report/billing","pageName":"NETWORK_REPORTS__BILLING","privacy":"PRIVATE"},{"pattern":"/dashboard/private-file","page":"dashboard/privateFile","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/team-assistant","page":"dashboard/team-assistant","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/assistant-metrics","page":"dashboard/assistant-metrics","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/news","page":"dashboard/news","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard/sso-crm","page":"dashboard/sso-crm","skipContractVersionVerification":true,"privacy":"PRIVATE"},{"pattern":"/dashboard","page":"dashboard","pageName":"DASHBOARD","privacy":"PRIVATE"},{"pattern":"/compartido-por-asesor-:externalBrokerName/:param1/:param2/:param3/:propertyId(\\\\d+)","page":"vip","privacy":"PUBLIC"},{"pattern":"/:param1/:param2/:param3/:propertyId(\\\\d+)/pdf-downloaded","page":"vip","privacy":"PUBLIC"},{"pattern":"/:param1/:param2/:param3/:propertyId(\\\\d+)/property-info-requested","page":"vip","privacy":"PUBLIC"},{"pattern":"/:param1/:param2/:param3/:propertyId(\\\\d+)/broker-telephone-requested","page":"vip","privacy":"PUBLIC"},{"pattern":"/:param1/:param2/:param3/:propertyId(\\\\d+)/property-reported","page":"vip","privacy":"PUBLIC"},{"pattern":"/:param1/:param2/:param3/:propertyId(\\\\d+)","page":"vip","privacy":"PUBLIC"},{"pattern":"/feature-properties","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/nuestras-propiedades","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/nuestras-propiedades/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/search","page":"srp","privacy":"PUBLIC"},{"pattern":"/search/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC"},{"pattern":"/:param1/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2/:param3/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2/:param3","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2/:param3/:param4/pagina-:page(\\\\d+)","page":"srp","privacy":"PUBLIC","seo":{"check":true}},{"pattern":"/:param1/:param2/:param3/:param4","page":"srp","privacy":"PUBLIC","seo":{"check":true}}]');

/***/ })

}]);